import { toast } from 'react-toastify';

import { find as findLodash, isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestEstoquePostos({ payload }) {
  try {
    const params = { ...payload.params };

    const wherefield = params.wherefield || [];
    const valuewherefield = params.valuewherefield || [];
    const typewherefield = params.typewherefield || [];

    if (params.wherefield && !findLodash(params.wherefield, 'statusposto')) {
      params.wherefield = [...wherefield, 'statusposto', 'tipoposto'];
      params.valuewherefield = [...valuewherefield, 'L', 'P'];
      params.typewherefield = [...typewherefield, 'EQUALS', 'EQUALS'];
    } else {
      params.wherefield = ['statusposto', 'tipoposto'];
      params.valuewherefield = ['L', 'P'];
      params.typewherefield = ['EQUALS', 'EQUALS'];
    }

    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteEstoquePosto({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `estoquespostoscomboios/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/estoqueposto');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `estoquespostoscomboios/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/estoqueposto');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const params = { ...payload.params };

    if (params.wherefield && !findLodash(params.wherefield, 'statusposto')) {
      params.wherefield = [...params.wherefield, 'statusposto'];
      params.valuewherefield = [...params.valuewherefield, 'L'];
      params.typewherefield = [...params.typewherefield, 'EQUALS'];
    } else {
      params.wherefield = ['statusposto'];
      params.valuewherefield = ['L'];
      params.typewherefield = ['EQUALS'];
    }

    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaoestoqueposto/ESTOQUEPOSTOS_IN_REQUEST',
    requestEstoquePostos
  ),
  takeLatest('@operacaoestoqueposto/DELETE_ESTOQUEPOSTO', deleteEstoquePosto),
  takeLatest('@operacaoestoqueposto/SUCCESS_REMOVE', requestEstoquePostos),
  takeLatest('@operacaoestoqueposto/STORE_ESTOQUEPOSTO', store),
  takeLatest('@operacaoestoqueposto/FIND_ESTOQUEPOSTO', find),
  takeLatest('@operacaoestoqueposto/UPDATE_ESTOQUEPOSTO', update),
  takeLatest('@operacaoestoqueposto/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaoestoqueposto/RESET_FILTERING', applyedFilters),
]);
